(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.getElementById('shopify-section-header');
this.headerBounds = {};
this.currentScrollTop = 0;
this.preventReveal = false;
this.predictiveSearch = this.querySelector('predictive-search');

this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => this.preventReveal = true;

this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);

this.createObserver();
}

disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

observer.observe(this.header);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (this.preventHide) return;
requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
if (!this.preventReveal) {
requestAnimationFrame(this.reveal.bind(this));
} else {
window.clearTimeout(this.isScrolling);

this.isScrolling = setTimeout(() => {
this.preventReveal = false;
}, 66);

requestAnimationFrame(this.hide.bind(this));
}
} else if (scrollTop <= this.headerBounds.top) {
requestAnimationFrame(this.reset.bind(this));
}

this.currentScrollTop = scrollTop;
}

hide() {
this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
this.closeMenuDisclosure();
this.closeSearchModal();
}

reveal() {
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.remove('shopify-section-header-hidden');
}

reset() {
this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}

closeMenuDisclosure() {
this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
this.disclosures.forEach(disclosure => disclosure.close());
}

closeSearchModal() {
this.searchModal = this.searchModal || this.header.querySelector('details-modal');
this.searchModal.close(false);
}
}

customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function() {
    $("#hero-carousel-slick").slick({
        dots: false,
        infinite: true,
        speed: 500,
        fade: true,
        cssEase: "linear",
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        pauseOnFocus: false,
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["six-products"] && !Shopify.designMode) return;
  try {
    
  class GalleryFilter {
    filtersSelector = '.cs-button';
    imagesSelector = '.cs-listing';
    activeClass = 'cs-active';
    hiddenClass = 'cs-hidden';

    constructor() {
      const $filters = document.querySelectorAll(this.filtersSelector);
      this.$activeFilter = $filters[0];
      this.$images = document.querySelectorAll(this.imagesSelector);

      this.$activeFilter.classList.add(this.activeClass);

      for (const $filter of $filters) {
        $filter.addEventListener('click', () => this.onClick($filter));
      }
    }

    onClick($filter) {
      this.filter($filter.dataset.filter);

      const { activeClass } = this;

      this.$activeFilter.classList.remove(activeClass);
      $filter.classList.add(activeClass);

      this.$activeFilter = $filter;
    }

    filter(filter) {
      const showAll = filter == 'all';
      const { hiddenClass } = this;

      for (const $image of this.$images) {
        const show = showAll || $image.dataset.category == filter;
        $image.classList.toggle(hiddenClass, !show);
      }
    }
  }

  new GalleryFilter();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["three-collections"] && !Shopify.designMode) return;
  try {
    
  class CS_GalleryFilter2 {
    filtersSelector = '.cs-button';
    galleriesSelector = '.cs-gallery';
    activeClass = 'cs-active';
    hiddenClass = 'cs-hidden';

    constructor() {
      this.$galleries = document.querySelectorAll(this.galleriesSelector);
      const $filters = document.querySelectorAll(this.filtersSelector);

      this.onClick($filters[0]);

      for (const $filter of $filters) {
        $filter.addEventListener('click', () => this.onClick($filter));
      }
    }

    onClick($filter) {
      this.filter($filter.dataset.filter);

      const { activeClass } = this;

      this.$activeFilter?.classList.remove(activeClass);
      $filter.classList.add(activeClass);

      this.$activeFilter = $filter;
    }

    filter(filter) {
      const showAll = filter == 'all';
      const { hiddenClass } = this;

      for (const $gallery of this.$galleries) {
        const show = showAll || $gallery.dataset.category == filter;
        $gallery.classList.toggle(hiddenClass, !show);
      }
    }
  }

  new CS_GalleryFilter2();

  } catch(e) { console.error(e); }
})();
})();
